import _ from "lodash";
import client from "lib/apolloClient/client";
import {
  getOrganizationPointSetQuery,
  getSubjectBasedCoursesQuery,
  getSubjectDetailsQuery,
  getSubjectGroupsQuery,
  getAssessmentsMappedToCategorySetQuery,
  getAssessmentsMappedToCategoryQuery,
} from "./ScoreCategoriesQueries";

export const getSubjectBasedCoursesFromCache = ({ variables }) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getSubjectBasedCoursesQuery,
      variables,
    });
  } catch (e) {
    return {};
  }
  return _.get(queryData, "node", {});
};

export const getSubjectDetailsFromCache = ({ variables }) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getSubjectDetailsQuery,
      variables,
    });
  } catch (e) {
    return {};
  }
  return _.get(queryData, "node", {});
};

export const getOrganizationPointSetFromCache = ({ variables }) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getOrganizationPointSetQuery,
      variables,
    });
  } catch (e) {
    return {};
  }
  return _.get(queryData, "node", {});
};

export const getOrganizationPointSet = async ({ variables }) => {
  const response = await client.query({
    query: getOrganizationPointSetQuery,
    variables,
    fetchPolicy: "network-only",
  });

  return _.get(response, "data.node", {});
};

export const getAssessmentsMappedToCategorySetFromCache = ({ variables }) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getAssessmentsMappedToCategorySetQuery,
      variables,
    });
  } catch (e) {
    return {};
  }

  return _.get(queryData, "node", {});
};

export const getAssessmentsMappedToCategoryFromCache = ({ variables }) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getAssessmentsMappedToCategoryQuery,
      variables,
    });
  } catch (e) {
    return {};
  }

  return _.get(queryData, "node", {});
};

export const getSubjectGroupsFromCache = variables => {
  try {
    const queryData = client.readQuery({
      query: getSubjectGroupsQuery,
      variables,
    });
    return _.get(queryData, "node", {});
  } catch (e) {
    return {};
  }
};
